import { head } from 'ramda'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useDynamicServiceOrdersState } from '../_load/DynamicServiceOrdersLoader'
import { useRowsActions } from './_actions/rowsActions'

const MultiRowsActions = () => {
  const { dynamicServiceOrders } = useDynamicServiceOrdersState()

  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedDynamicServiceOrders = getSelectedData(dynamicServiceOrders)
  const [menuOptions] = useRowsActions(head(selectedDynamicServiceOrders), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
